import React from 'react';

import { shipmentDirections } from 'shared/helpers/constants/shipments/shipmentDirections';

import { ShipmentsList } from '../ShipmentsList';

function OutgoingShipmentsList(props) {
  return (
    <ShipmentsList
      getShipmentsList={props.getShipmentsList}
      shipmentDirection={shipmentDirections.outgoing}
      {...props}
    />
  );
}

export { OutgoingShipmentsList };
